import React from 'react';
import I18n from 'i18n-js';

import SiteModule from '@reverbdotcom/commons/src/components/site_module';
import FormGroup from '@reverbdotcom/commons/src/components/form_group';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { RCTag } from '@reverbdotcom/commons/src/rc/RCTag';

import URLHelpers from '../../shared/url_helpers';

interface IProps {
  prefersReverbShippingLabel: boolean;
  onChange: (val) => void;
}

function RSLSelectorFooterModule() {
  return (
    <ul className="rsl-selector-module__list-group">
      <li className="rsl-selector-module__list-item">
        {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.valueProps.savePrice')}
      </li>
      <li className="rsl-selector-module__list-item">
        <SanitizedRender
          htmlTag="div"
          html={I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.valueProps.safeShipping',
            {
              linkOpen: `<a href=${URLHelpers.sellingSafeShippingInfoPath} target="_blank" class="text-link">`,
              linkClose: '</a>',
            },
          )}
        />
      </li>
      <li className="rsl-selector-module__list-item">
        {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.valueProps.printLabel')}
      </li>
    </ul>
  );
}

export const COMPONENT_NAME = 'ReverbShippingLabelSelector';

export function ReverbShippingLabelSelector({
  prefersReverbShippingLabel = true,
  onChange,
}: IProps) {

  return (
    <div className="mb-2">
      <FormGroup
        label={I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.title')}
      >
        <SiteModule footerContent={RSLSelectorFooterModule()}>
          <div className="label-with-radio">
            <input
              onChange={() => onChange(true)}
              type="radio"
              name="product[prefers_reverb_shipping_label]"
              id="rsl-radio"
              checked={prefersReverbShippingLabel}
              value="1"
              required
            />
            <label className="size-110" htmlFor="rsl-radio">
              <span className="mr-1">
                {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.revebShippingLabel')}
              </span>
              <RCTag variant="highlight">
                {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.tag')}
              </RCTag>
            </label>
            <p className="rsl-selector-module__help-text">
              {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.helpText')}
            </p>
          </div>
        </SiteModule>
        <SiteModule>
          <div className="label-with-radio">
            <input
              onChange={() => onChange(false)}
              type="radio"
              name="product[prefers_reverb_shipping_label]"
              id="custom-label-radio"
              checked={!prefersReverbShippingLabel}
              value="0"
              required
            />
            <label className="size-110" htmlFor="custom-label-radio">
              {I18n.t('discovery.dashboard.selling.shippingLabels.reverbShippingLabelSelector.customLabel')}
            </label>
          </div>
        </SiteModule>
      </FormGroup>
    </div>
  );
}

// The label selector UI is used in legacy view contexts in core, where it does not operate as a controlled component.
// This default export is uncontrolled, and allows us to maintain the expected contract when injected in rails views.
// The component itself can be exported + used as a controlled component in new frontend contexts.
export default function UncontrolledReverbShippingLabelSelector({ prefersReverbShippingLabel = true }: { prefersReverbShippingLabel?: boolean }) {
  const [isSelected, setIsSelected] = React.useState(prefersReverbShippingLabel);

  return (<ReverbShippingLabelSelector prefersReverbShippingLabel={isSelected} onChange={setIsSelected} />);
}
